// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"y1-z","subtitle":"z1-z","wrapper":"A1-z","leftArrow":"B1-z","rightArrow":"C1-z"};